/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuerySource } from './query-source';
import { ResultFreshness } from './result-freshness';
import { ExecutionResultDto } from './execution-result-dto';
import { QueryLane } from './query-lane';


export interface ExecutionDto { 
    _id: string;
    program?: string;
    userId: string;
    jobId: string;
    query: string;
    /**
     * sha1 of the gated SQL — set for read queries so identical queries can share results.
     */
    queryHash?: string;
    /**
     * True when the result was served from the query-result cache instead of the warehouse.
     */
    cacheHit?: boolean;
    result?: ExecutionResultDto;
    error?: string;
    status: ExecutionDto.StatusEnum;
    /**
     * Execution time in seconds
     */
    spentTime: number;
    /**
     * When a worker started running the query against the warehouse.
     */
    startedAt?: string;
    /**
     * Warehouse run time in milliseconds, set once the query finished. Absent on a cache hit.
     */
    durationMs?: number;
    /**
     * True when the warehouse run took at least the slow threshold (5 s by default).
     */
    slow?: boolean;
    /**
     * Machine-readable reason of a failed run: QUERY_TIMEOUT when the warehouse stopped it at the statement cap, QUERY_CANCELLED (status cancelled) when the warehouse cancelled it on request.
     */
    errorCode?: ExecutionDto.ErrorCodeEnum;
    /**
     * When the result was computed: the end of the warehouse run, or of the run a cache hit reuses.
     */
    computedAt?: string;
    /**
     * Set on a cache hit: fresh inside the cache window, stale when a background refresh is already on its way.
     */
    freshness?: ResultFreshness;
    /**
     * Worker lane that ran the query.
     */
    lane?: QueryLane;
    /**
     * Who asked for the run: a viewer, the agent or a background refresh.
     */
    source?: QuerySource;
    /**
     * KPI the query belongs to, when it came from a KPI run or a dashboard tile.
     */
    kpiId?: string;
    /**
     * KPI version the query belongs to, when it came from a KPI run or a dashboard tile.
     */
    kpiVersionId?: string;
    /**
     * Planner cost estimate of the query (EXPLAIN Total Cost), recorded to calibrate slow-query warnings.
     */
    explainCost?: number;
    connection: string;
    completion: string;
}
export namespace ExecutionDto {
    export const StatusEnum = {
        Error: 'error',
        Pending: 'pending',
        Running: 'running',
        Success: 'success',
        Generating: 'generating',
        Cancelled: 'cancelled'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const ErrorCodeEnum = {
        QueryTimeout: 'QUERY_TIMEOUT',
        QueryCancelled: 'QUERY_CANCELLED'
    } as const;
    export type ErrorCodeEnum = typeof ErrorCodeEnum[keyof typeof ErrorCodeEnum];
}


